import React, {Fragment} from "react";
import {MontageType} from "../../../Model";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageMuur from '../../../images/situation/montage/muurmontage.jpg';
import imageKozijn from '../../../images/situation/montage/kozijnmontage.jpg';
import PickerInfoBox from "../../../components/PickerInfoBox";

MontageWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
}
export default function MontageWindow(props) {
    return <Fragment>
        <div className="phone-page-middle">

            <div className="phone-situation-title">
                Hier kunt u aangeven of de situatie op de muur wordt gemonteerd of op het kozijn.<br/>
            </div>
            <div className="phone-pick-body">
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={MontageType.MUUR}
                                  image={imageMuur}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={MontageType.KOZIJN}
                                  image={imageKozijn}
                                  medium/>
            </div>
        </div>
        <PickerInfoBox
            options={[
                {value: MontageType.MUUR, text: "Beslag wordt bevestiged op de muur"},
                {value: MontageType.KOZIJN, text: "Beslag wordt bevestiged op het kozijn"},
            ]}
            current={props.currentValue}
            sticky
        />
    </Fragment>
}